import React from 'react';
import PropTypes from 'prop-types';
import className from './style.module.scss';

export function ColorCheckBox(props) {
  const onChange = (event) => {
    const {name, value, checked} = event.target;
    props.onChange({name, value, checked});
  };

  const setClassName = () => {
    if (props.disabled) {
      return ` ${className.checkbox} ${className.disabled}`;
    }
    return className.checkbox;
  };

  return (
    <label className={setClassName()} style={props.style}>
      <span className={className.checkbox_text}>{props.label}</span>
      <input
        type='radio'
        name={props.name}
        value={props.value}
        onChange={onChange}
        checked={props.checked}
        className={className.checkbox_input}
        disabled={props.disabled}
      />
      <span className={className.checkbox_box}></span>
    </label>
  );
}

ColorCheckBox.propTypes = {
  /**
   * name prop to set on radio-button
   */
  name: PropTypes.string,
  /**
   * Value prop to set on radio button
   */
  value: PropTypes.string,
  /**
   * Boolean to set if radio is checked
   */
  checked: PropTypes.bool,
  /**
   * Function involked when radio checked
   */
  onChange: PropTypes.func,
  /**
   * label for the option
   */
  label: PropTypes.string,
  /**
   * style object to set on checkbox
   */
  style: PropTypes.object,
  /**
   * Boolean to set if option is disabled
   */
  disabled: PropTypes.bool,
};

ColorCheckBox.defaultProps = {
  style: {
    backgroundColor: '#00aeef',
    color: '#fff',
  },
};
